import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, unref as _unref, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "flex-fill",
  style: {"word-break":"break-word"}
}
const _hoisted_2 = { class: "text-right pl-3 lh-1" }


import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "DaemonCountRow"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    descr: {},
    critical: { type: Boolean },
    value: {},
    clickable: { type: Boolean },
    rps: {},
    small: { type: Boolean }
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

let props = __props;

let emits = __emit

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
            'd-flex min-width-0 pr-3 pl-3 w-100 mw-100 counter-row align-items-center ': true,
            'pt-2 pb-2': !__props.small,
            'pt-1 pb-1': __props.small,
            'clickable': __props.clickable
        }),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(emits)('click')))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "descr"),
      _createTextVNode(" " + _toDisplayString(__props.descr) + " ", 1),
      (typeof __props.rps === 'number')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode(" (" + _toDisplayString(__props.rps) + "/sec) ", 1)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_2, [
      (__props.critical)
        ? (_openBlock(), _createBlock(_component_el_tag, {
            key: 0,
            type: "danger",
            style: {"transform":"translateX(10px)"}
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.value), 1)
            ]),
            _: 1
          }))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode(_toDisplayString(__props.value), 1)
          ], 64))
    ])
  ], 2))
}
}

})